import React from "react";

const ListViewIcon = ({
  width,
  height,
  className,
  setChangeView,
  changeView,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 27 18'
      fill='none'
      className={className}
      onClick={() => setChangeView(!changeView)}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 16.2368H1'
        stroke='#303030'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M1 9.23681L21 9.23682'
        stroke='#303030'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M1 2.23681L21 2.23682'
        stroke='#303030'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <rect
        x='24.0005'
        y='0.580322'
        width='3'
        height='3'
        rx='1.5'
        fill='#303030'
      />
      <rect
        x='24.0005'
        y='7.41968'
        width='3'
        height='3'
        rx='1.5'
        fill='#303030'
      />
      <rect
        x='24.0005'
        y='14.4197'
        width='3'
        height='3'
        rx='1.5'
        fill='#303030'
      />
    </svg>
  );
};

export default ListViewIcon;
